import { render } from "./ChatWindow.vue?vue&type=template&id=2485a803&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatWindow.vue?vue&type=script&setup=true&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=2485a803&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2485a803"],['__file',"src/common/widgets/ChatWindow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2485a803"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2485a803', __exports__)) {
    api.reload('2485a803', __exports__)
  }
  
  module.hot.accept("./ChatWindow.vue?vue&type=template&id=2485a803&scoped=true", () => {
    api.rerender('2485a803', render)
  })

}


export default __exports__